import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { SearchContext } from './Contexts/Context';
import { getMoadgileebi } from '../service/service';

function MerisMoadgileebi() {
	const ref = useRef(null);
	const { language } = useContext(SearchContext);
	const [moadgileebi, setMoadgileebi] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const merisMoadgileebi = async () => {
			try {
				const data = await getMoadgileebi();
				setMoadgileebi(data);
				setLoading(false);
			} catch (error) {
				console.error('Error fetching meris moadgileebi:', error);
				setLoading(true);
			}
		};
		merisMoadgileebi();
	}, []);

	


	const MoadgileebiCard = ({ img, name, position, }) => {
		return (
			<div className='moadgileebi-card'>
				<div className="profile-image">
					<img src={img} alt={name} />
				</div>
				<div className='moadgileebi-card-content'>
				<h3>{name}</h3>
				<p>{position}</p>
			</div>
			</div>
		)
	}
	

	return (
		<div>
			<motion.div
				intial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
			>
				<div className='news-container margin-280px'>
					<header>
						<span className='big' ref={ref} style={{ marginRight: '50px' }}>
							{' '}
							{language == 1 ? 'მერია' : 'KHULO CITY HALL'}
						</span>
						<span>
							მერის მოადგილეები
						</span>
					</header>
					<div>
						<div className='meris-moadgileebi'>
							{loading ? (
								<p>Loading...</p>
							) : (
								moadgileebi.map((moadgile) => (
									<Link to={`/meris-moadgileebi/${moadgile.slug}`} key={moadgile.id}>
										<MoadgileebiCard img={moadgile.image} name={moadgile.full_name} position={moadgile.position} />
									</Link>
								))
							)}
						</div>
					
					</div>
				</div>
			</motion.div>
		</div>
	);
}

export default MerisMoadgileebi;
